import "../App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min";
import Header from "../component/header";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Accordion from "react-bootstrap/Accordion";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import Whatsapp from "../assets/images/whatapp.svg";
import BetSlipContext from "../context/BetSlipContext";
import { useState, useEffect, useContext } from "react";
import { isEmpty } from "lodash";
import { apiGet } from "../Utils/apiFetch";
import apiPath from "../Utils/apiPath";
import OpenBets from "../component/OpenBets";
import AuthContext from "../context/AuthContext";
import loading from "../img/loading_bet.webp";
import CalendarComponent from "../component/Calendar";
import AfterLoginImage from "../assets/images/loginBanner-new.jpg";
import { TiDelete } from "react-icons/ti";
import { Modal } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import English from "../img/icons/united-kingdom.png";
import Arabic from "../img/icons/united-arab-emirates.png";
import Kannad from "../img/icons/kannad.png";
import Hindi from "../img/icons/square.png";
import Spanish from "../img/icons/flag.png";
import Select, { components } from "react-select";
import EvolutionModal from "../component/EvolutionModal";
import Setting from "../component/Setting";
import Promo from "../component/Promo";
import Login from "./login";
import Register from "./Register";
import ForgotPassword from "./ForgotPassword";
import ChangePassProfile from "./changePassProfile";
import SearchEvent from "../component/SearchEvent";
import LoadingImage from "../assets/images/cover-live.png";
function Layout({ children }) {
  const params = useParams();
  const { t } = useTranslation();
  const location = useLocation();
  const [tournamentData, setTournamentData] = useState([]);
  const navigate = useNavigate();
  const {
    rightTab,
    setRightTab,
    showDate,
    totalCount,
    user,
    afterLogin,
    setAfterLogin,
    profileData,
    languageShow,
    setLanguageShow,
    changeLanguage,
    evolutionModal,
    setEvolutionModal,
    setting,
    channel,
    showTv,
    loginModal,
    regiterModal,
    forgotShow,
    changeShow,
    showSearch,
  } = useContext(AuthContext);
  const { betSlipObject, betLoader, resetBetPosition, unMatchedBets } =
    useContext(BetSlipContext);
  const sortBy = (array) => {
    return array?.sort(function (a, b) {
      return new Date(b.createdAt) - new Date(a.createdAt);
    });
  };
  const [showChannel, setShowChannel] = useState(false);
  const getTournamentData = async () => {
    const { status, data: response_users } = await apiGet(apiPath.seriesList);
    if (status === 200) {
      if (response_users.success) {
        setTournamentData({
          cricket:
            response_users.results?.filter((res) => {
              return res?.gameType == "cricket";
            }) || [],
          tennis:
            response_users.results?.filter((res) => {
              return res?.gameType == "tennis";
            }) || [],
          soccer:
            response_users.results?.filter((res) => {
              return res?.gameType == "soccer";
            }) || [],
          all: sortBy(response_users.results),
        });
      }
    }
  };

  useEffect(() => {
    getTournamentData();
  }, []);

  const [data, setData] = useState([]);
  const [isLoaded, setIsLoaded] = useState(false);
  const getCurrentBets = async () => {
    const { status, data: response_users } = await apiGet(
      apiPath.mobileCurrentBets
    );
    // getBetsData
    if (status === 200) {
      if (response_users.success) {
        setData(response_users.results);
      }
    }
  };

  useEffect(() => {
    if ((rightTab == "openBet" && !isEmpty(user)) || resetBetPosition) {
      getCurrentBets();
    }
  }, [rightTab, user, resetBetPosition]);

  const countries = [
    { value: "en", label: "English", icon: English },
    { value: "ka", label: "Kannad", icon: Kannad },
    { value: "ar", label: "Arabic", icon: Arabic },
    { value: "sp", label: "Spanish", icon: Spanish },
    { value: "hi", label: "Hindi", icon: Hindi },
  ];
  const Option = (props) => (
    <components.Option
      {...props}
      className="country-option"
      style={{ padding: "3px 10px", marginBottom: "10px" }}
    >
      <img
        style={{ width: "20px", marginRight: "10px" }}
        src={props.data.icon}
        alt="logo"
        className="country-logo"
      />
      {props.data.label}
    </components.Option>
  );
  const SingleValue = ({ children, ...props }) => (
    <components.SingleValue {...props}>
      <img
        style={{ width: "20px", marginRight: "10px" }}
        src={
          isEmpty(localStorage.getItem("language_dir"))
            ? English
            : countries?.find((res) => {
                return res?.value == localStorage.getItem("language_dir");
              })?.icon
        }
        alt="s-logo"
        className="selected-logo"
      />
      {children}
    </components.SingleValue>
  );

  let find =
    profileData?.banners?.find((res) => {
      return res?.type == "home_popup";
    }) || {};

  useEffect(() => {
    if (!["match"].includes(location?.pathname?.split("/")[1])) {
      setRightTab("openBet");
    }
  }, [location]);
  return (
    <div style={betLoader ? { cursor: "not-allowed" } : {}}>
      {" "}
      {languageShow && (
        <Modal centered show={languageShow}>
          <Modal.Body className="position-relative p-0">
            <div className="d-flex flex-column align-items-start p-3">
              <span className="mb-2">Select Language</span>
              <Select
                className="w-100"
                value={
                  isEmpty(localStorage.getItem("language_dir"))
                    ? English
                    : countries?.find((res) => {
                        return (
                          res?.value == localStorage.getItem("language_dir")
                        );
                      })
                }
                options={countries}
                onChange={(e) => changeLanguage(e.value)}
                styles={{
                  singleValue: (base) => ({
                    ...base,
                    display: "flex",
                    alignItems: "center",
                  }),
                }}
                components={{ Option, SingleValue }}
              />
            </div>
          </Modal.Body>
        </Modal>
      )}
      {setting?.status && <Setting />}
      {afterLogin && !isEmpty(find) && (
        <Modal
          size="xl"
          centered
          show={afterLogin}
          onHide={() => setAfterLogin(false)}
        >
          <Modal.Body className="position-relative p-0">
            <TiDelete
              onClick={() => setAfterLogin(false)}
              color="white"
              style={{ position: "absolute", right: "-1%", top: "-2%" }}
              size={30}
            />
            <img
              style={{ width: "100%" }}
              src={
                !isEmpty(find)
                  ? `${process.env.REACT_APP_API_BASE_URL}${find?.banner_path}`
                  : ''
              }
            />
          </Modal.Body>
        </Modal>
      )}
      {!["match", "customer-support"].includes(
        location?.pathname?.split("/")[1]
      ) && (
        <div>
          <img
            src={Whatsapp}
            onClick={() => {
              // if (isEmpty(user)) {
              //   navigate("/login");
              // } else {
              //   navigate("/customer-support");
              // }

              window.open("https://api.whatsapp.com/send?phone=918623036258");
            }}
            style={{
              position: "fixed",
              bottom: "5%",
              left: "5%",
              zIndex: "99999999999999999",
            }}
          />
          {/* {totalCount > 0 && (
            <span
              style={{
                position: "fixed",
                bottom: "10.5%",
                left: "7.5%",
                zIndex: "99999999999999999",
                background: "red",
                color: "white",
                borderRadius: "50%",
                padding: "0 4px",
              }}
            >
              {totalCount}
            </span>
          )} */}
        </div>
      )}
      {betLoader && (
        <div className="loading-bet">
          <img src={loading} />
        </div>
      )}
      <>
        <Header />
        <div className="d-flex w-100">
          {!["deposit", "withdraw", "promotional"].includes(
            location?.pathname?.split("/")[1]
          ) && (
            <div className="left-menu">
              <div className="LeftTabs">
                <Tabs
                  fill
                  defaultActiveKey="betslip"
                  id="uncontrolled-tab-example"
                >
                  <Tab eventKey="betslip" title={"Popular"}>
                    <Accordion activeKey={["0", "1", "2"]}>
                      <Accordion.Item eventKey="0">
                        <Accordion.Header>{t("Cricket")}</Accordion.Header>
                        {tournamentData?.cricket?.length > 0 && (
                          <Accordion.Body>
                            <ul>
                              {tournamentData?.cricket?.map((res) => {
                                return (
                                  <li>
                                    <Link to={`/${res?.gameType}`}>
                                      {res?.seriesName}
                                    </Link>
                                  </li>
                                );
                              })}
                            </ul>
                          </Accordion.Body>
                        )}
                      </Accordion.Item>
                      <Accordion.Item eventKey="1">
                        <Accordion.Header>{t("Soccer")}</Accordion.Header>
                        {tournamentData?.soccer?.length > 0 && (
                          <Accordion.Body>
                            <ul>
                              {tournamentData?.soccer?.map((res) => {
                                return (
                                  <li>
                                    <Link to={`/${res?.gameType}`}>
                                      {res?.seriesName}
                                    </Link>
                                  </li>
                                );
                              })}
                            </ul>
                          </Accordion.Body>
                        )}
                      </Accordion.Item>
                      <Accordion.Item eventKey="2">
                        <Accordion.Header>{t("Tennis")}</Accordion.Header>
                        {tournamentData?.tennis?.length > 0 && (
                          <Accordion.Body>
                            <ul>
                              {tournamentData?.tennis?.map((res) => {
                                return (
                                  <li>
                                    <Link to={`/${res?.gameType}`}>
                                      {res?.seriesName}
                                    </Link>
                                  </li>
                                );
                              })}
                            </ul>
                          </Accordion.Body>
                        )}
                      </Accordion.Item>
                    </Accordion>
                  </Tab>
                </Tabs>
              </div>
            </div>
          )}

          <div
            className={` ${
              !["deposit", "withdraw", "promotional"].includes(
                location?.pathname?.split("/")[1]
              )
                ? "right-con"
                : "w-100"
            } pb-0`}
          >
            <Row className="m-0">
              {children}

              {!["casino", "deposit", "withdraw", "promotional"].includes(
                location?.pathname?.split("/")[1]
              ) && (
                <Col md={3} className="p-0">
                  <div className="lb-box mb-1">
                    {location?.pathname?.split("/")[1] == "match" &&
                      showTv &&
                      !isEmpty(channel) && (
                        <div>
                          <div
                            style={{
                              position: "relative",
                              background: "rgb(48, 48, 48)",
                              color: "white",
                              fontWeight: "600",
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                              padding: "6px 5px",
                            }}
                          >
                            Live TV{" "}
                            <label class="switch-new">
                              <input
                                checked={showChannel}
                                onClick={(e) =>
                                  setShowChannel(e.target.checked)
                                }
                                type="checkbox"
                              />
                              <span class="slider round"></span>
                            </label>
                          </div>
                          {/* 
                          {channel && showChannel && (
                            <>
                              <iframe
                                title="Live TV Player"
                                src={`https://3xbdt.live:5443/live-tv/${channel}`}
                                id="ContentPlaceHolder1_myFrame1"
                                className="responsive-iframe sc-dUjcNx eLUYUT"
                                allowFullScreen
                                style={{ width: "100%", height: "100%" }}
                              />
                            </>
                          )} */}

                          {channel && showChannel && (
                            <div
                              className="scroll-container"
                              style={{
                                position: "relative",
                                paddingBottom: "56.25%",
                                height: 0,
                                overflow: "hidden",
                              }}
                            >
                              {!isLoaded && (
                                <div
                                  style={{
                                    position: "absolute",
                                    top: "50%",
                                    left: "50%",
                                    transform: "translate(-50%, -50%)",
                                    zIndex: 2,
                                    width: "100%",
                                    height: "100%",
                                  }}
                                >
                                  <img
                                    src={LoadingImage}
                                    alt="Thumbnail"
                                    style={{
                                      overflowY: "hidden",
                                      height: "auto",
                                      width: "100%",
                                      overflowX: "hidden",
                                      overflowY: "hidden",
                                    }}
                                  />
                                </div>
                              )}
                              <iframe
                                title="Live TV Player"
                                src={`https://3xbdt.live:5443/tv/${channel}`}
                                id="ContentPlaceHolder1_myFrame1"
                                onLoad={() => setIsLoaded(true)}
                                style={{
                                  position: "absolute",
                                  top: 0,
                                  left: 0,
                                  width: "100%",
                                  height: "100%",
                                  border: "none",
                                  overflow: "none",
                                  opacity: isLoaded ? 1 : 0,
                                  transition: "opacity 0.3s ease-in-out",
                                }}
                                className="sc-dUjcNx eLUYUT"
                              />
                            </div>
                          )}
                        </div>
                      )}
                    <Tabs
                      style={{ borderBottom: "1px solid #F1F1FF" }}
                      fill
                      activeKey={rightTab}
                      onSelect={(e) => setRightTab(e)}
                      // defaultActiveKey={"openBet"}
                      className="right-side"
                    >
                      <Tab eventKey="openBet" title={"Market Bets"}>
                        <OpenBets rightTab={rightTab} data={data} />
                      </Tab>{" "}
                      <Tab eventKey="unmatch" title={"UnMatch Bets"}>
                        <OpenBets rightTab={rightTab} data={unMatchedBets} />
                      </Tab>
                    </Tabs>
                  </div>
                  {location?.pathname?.split("/")[1] != "match" && <Promo />}
                </Col>
              )}
            </Row>
          </div>
        </div>
      </>
      {evolutionModal?.status && (
        <EvolutionModal
          show={evolutionModal?.status}
          handelClose={() => setEvolutionModal({ data: {}, status: false })}
        />
      )}
      {showSearch && <SearchEvent />}
      {showDate?.status && !isEmpty(showDate?.type) && <CalendarComponent />}
      {loginModal && <Login />}
      {regiterModal && <Register />} {forgotShow && <ForgotPassword />}
      {changeShow && <ChangePassProfile />}
    </div>
  );
}

export default Layout;

{
  /* <div className="btmBox mb-0 text-center fs-12 p-3">
              &copy; {t("copyright")}
            </div> */
}
const casinoList = [
  {
    title: "Indian Poker",
    key: "poker",
    key: "Indian_Poker",
  },
  {
    title: "Royal Gamming",
    key: "Royal Gamming",
  },
  {
    title: "Aviator",
    key: "Aviator",
    key: "Aviator",
  },
  {
    title: "Live",
    key: "Live",
    key: "Live",
  },
  {
    title: "Table",
    key: "Table",
    key: "Table",
  },
  {
    title: "Slot",
    key: "Slot",
    key: "Slot",
  },
  {
    title: "Dice",
    key: "Dice",
    key: "Dice",
  },
  {
    title: "Fishing",
    key: "Fishing",
    key: "Fishing",
  },
  {
    title: "Egame",
    key: "Egame",
    key: "Egame",
  },
  {
    title: "AWC",
    key: "AWC",
    key: "AWC",
  },
];
